"use strict";

exports.__esModule = true;
exports.OperatorDeviceSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _Theme = require("../../Theme");
var _Timer = require("../../Time/Timer");
var _Utils = require("../../../Utils");
var _DeviceState = require("../../Widgets/Grid/DeviceState");
var _TileContext = require("../../Widgets/common/TileContext");
var _stateEdge = require("../../Widgets/common/stateEdge");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// The device picker from the next-gen design: each machine is a card like
// the heat map's, with a state-coloured edge, its name and its current state,
// and the selected card carries the primary ring.
var NEUTRAL_ACCENT = "#D5DDE2";
var RING_COLOR = "#E8621E";
var safeMix = function safeMix(amount, color, base) {
  try {
    return (0, _polished.mix)(amount, color, base);
  } catch (e) {
    return base;
  }
};
var DeviceSelectorView = _styledComponents["default"].div.withConfig({
  displayName: "OperatorDeviceSelectormodern__DeviceSelectorView",
  componentId: "sc-vdmaxx-0"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));grid-auto-rows:max-content;gap:14px;padding:4px 4px 24px;"]);
var DeviceCardButton = _styledComponents["default"].button.withConfig({
  displayName: "OperatorDeviceSelectormodern__DeviceCardButton",
  componentId: "sc-vdmaxx-1"
})(["all:unset;position:relative;box-sizing:border-box;display:flex;flex-direction:column;gap:6px;min-height:120px;padding:calc(", " + 12px) 40px 14px 16px;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;text-align:left;color:#1b2227;background:#ffffff;border-radius:12px;box-shadow:", ";overflow:hidden;transition:box-shadow 120ms ease,transform 120ms ease;&:hover,&:focus-visible{box-shadow:", ";transform:translateY(-1px);}&[aria-selected=\"true\"]{box-shadow:", ",0 0 0 2px ", ";}&::after{content:\"\u203A\";position:absolute;right:16px;top:50%;transform:translateY(-55%);font-size:22px;line-height:1;color:#b9c4cb;}"], _stateEdge.STATE_EDGE_CSS, (0, _Theme.val)("CardShadow"), (0, _Theme.val)("CardShadowRaised"), (0, _Theme.val)("CardShadow"), RING_COLOR);

// Percent padding is relative to the card's width, so the edge grows with
// the card.
var Accent = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__Accent",
  componentId: "sc-vdmaxx-2"
})(["position:absolute;left:0;right:0;top:0;height:0;padding-top:", ";transition:background 0.4s ease;"], _stateEdge.STATE_EDGE_CSS);
var Name = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__Name",
  componentId: "sc-vdmaxx-3"
})(["font-family:", ";font-size:18px;font-weight:700;letter-spacing:-0.01em;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], _TileContext.FLAT_FONT_HEADING);
var StateLine = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__StateLine",
  componentId: "sc-vdmaxx-4"
})(["display:flex;align-items:center;gap:7px;min-width:0;overflow:hidden;"]);
var Dot = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__Dot",
  componentId: "sc-vdmaxx-5"
})(["flex:none;width:8px;height:8px;border-radius:50%;"]);
var StateText = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__StateText",
  componentId: "sc-vdmaxx-6"
})(["flex:0 1 auto;min-width:0;font-size:13.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var Since = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__Since",
  componentId: "sc-vdmaxx-7"
})(["flex:none;font-family:", ";font-size:11.5px;color:#7c8a94;white-space:nowrap;"], _TileContext.FLAT_FONT_MONO);
var Hint = _styledComponents["default"].span.withConfig({
  displayName: "OperatorDeviceSelectormodern__Hint",
  componentId: "sc-vdmaxx-8"
})(["margin-top:auto;font-size:11.5px;font-weight:700;letter-spacing:0.07em;text-transform:uppercase;color:#8b959a;"]);
function DeviceCard(_ref) {
  var device = _ref.device,
    selected = _ref.selected,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_DeviceState.DeviceStateSubscription, {
    deviceUuid: device.uuid
  }, function (_ref2) {
    var text = _ref2.text,
      color = _ref2.color,
      startMillis = _ref2.startMillis;
    var accent = color && color !== "transparent" ? color : NEUTRAL_ACCENT;
    return /*#__PURE__*/_react["default"].createElement(DeviceCardButton, {
      type: "button",
      "data-testid": "OperatorDeviceSelector." + device.uuid,
      "aria-selected": selected,
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement(Accent, {
      style: {
        background: accent
      }
    }), /*#__PURE__*/_react["default"].createElement(Name, {
      title: device.name
    }, device.name), /*#__PURE__*/_react["default"].createElement(StateLine, null, /*#__PURE__*/_react["default"].createElement(Dot, {
      style: {
        background: accent
      }
    }), /*#__PURE__*/_react["default"].createElement(StateText, {
      style: {
        color: safeMix(0.35, "#1B2227", accent)
      }
    }, text || "No state"), startMillis > 0 && /*#__PURE__*/_react["default"].createElement(_Timer.Timer, {
      interval: 30000
    }, function (_ref3) {
      var now = _ref3.now;
      return /*#__PURE__*/_react["default"].createElement(Since, null, "for ", (0, _Utils.formatDuration)(Math.max(0, now - startMillis)));
    })), /*#__PURE__*/_react["default"].createElement(Hint, null, selected ? "Selected" : "Open panel"));
  });
}

/**
 * Allows an operator to select a device from a list.
 */
var OperatorDeviceSelector = exports.OperatorDeviceSelector = /*#__PURE__*/function (_Component) {
  function OperatorDeviceSelector() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(OperatorDeviceSelector, _Component);
  var _proto = OperatorDeviceSelector.prototype;
  _proto.createClickHandler = function createClickHandler(device) {
    var _this = this;
    return function () {
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        multiple = _this$props.multiple,
        selected = _this$props.selected;
      var updated = [];
      if (multiple) {
        var found = false;
        for (var i = 0; i < selected.length; i++) {
          var item = selected[i];
          if (item.uuid === device.uuid) {
            found = true;
          } else {
            updated.push(item);
          }
        }
        if (!found) {
          updated.push(device);
        }
      } else if (selected.length === 0 || selected[0].uuid !== device.uuid) {
        updated.push(device);
      }
      onSelect(updated);
    };
  };
  _proto.isDeviceSelected = function isDeviceSelected(device) {
    var selected = this.props.selected;
    for (var i = 0; i < selected.length; i++) {
      if (selected[i].uuid === device.uuid) {
        return true;
      }
    }
    return false;
  };
  _proto.render = function render() {
    var _this2 = this;
    var devices = this.props.devices;
    return /*#__PURE__*/_react["default"].createElement(DeviceSelectorView, {
      "data-testid": "OperatorDeviceSelector"
    }, devices.map(function (device) {
      return /*#__PURE__*/_react["default"].createElement(DeviceCard, {
        key: device.uuid,
        device: device,
        selected: _this2.isDeviceSelected(device),
        onClick: _this2.createClickHandler(device)
      });
    }));
  };
  return OperatorDeviceSelector;
}(_react.Component);
OperatorDeviceSelector.defaultProps = {
  selected: [],
  multiple: false
};